(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  root.FireCalculatorEngine = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var YEARLY_401K_CONTRIBUTION_CAP = 23500;

  function normalizeContribution401k(contribution401k, contributionMultiplier) {
    if (contribution401k * contributionMultiplier <= YEARLY_401K_CONTRIBUTION_CAP) {
      return contribution401k;
    }
    return YEARLY_401K_CONTRIBUTION_CAP / contributionMultiplier;
  }

  function calculate(input) {
    var balances = (input.initialBalances || []).slice();
    var contributions = (input.contributions || []).slice();
    var contributionMultiplier = input.contributionFrequency === 'monthly' ? 12 : 1;
    var years = [];

    contributions[0] = normalizeContribution401k(contributions[0] || 0, contributionMultiplier);

    for (var year = 0; year <= (input.retirementAge - input.currentAge); year++) {
      var age = input.currentAge + year;
      var total = balances.reduce(function (sum, value) { return sum + value; }, 0);

      years.push({
        year: year + 1,
        age: age,
        balances: balances.slice(),
        total: total
      });

      for (var i = 0; i < balances.length; i++) {
        var annualContribution = (contributions[i] || 0)
          * contributionMultiplier
          * Math.pow(1 + (input.contributionIncrease || 0) / 100, year);

        if (contributionMultiplier === 12) {
          // Monthly frequency is documented in the UI as twelve compounding
          // deposits per year, so compound at growthRate/12 and deposit at the
          // end of each month instead of adding one end-of-year lump sum.
          var monthlyRate = input.growthRate / 100 / 12;
          var monthlyContribution = annualContribution / 12;

          for (var month = 0; month < 12; month++) {
            balances[i] = balances[i] * (1 + monthlyRate) + monthlyContribution;
          }
        } else {
          balances[i] = balances[i] * (1 + input.growthRate / 100) + annualContribution;
        }
      }
    }

    return {
      normalizedContribution401k: contributions[0],
      years: years
    };
  }

  return {
    YEARLY_401K_CONTRIBUTION_CAP: YEARLY_401K_CONTRIBUTION_CAP,
    normalizeContribution401k: normalizeContribution401k,
    calculate: calculate
  };
});
